import {
  CreateDateColumn,
  UpdateDateColumn,
  Entity,
  Index,
  Column,
  RelationId,
  ManyToOne,
  OneToMany,
  PrimaryGeneratedColumn
} from 'typeorm'
import { ObjectType, Field, Int, ID, registerEnumType } from 'type-graphql'

import { Domain } from '@things-factory/shell'
import { User } from '@things-factory/auth-base'
import { Board } from '../board/board.js'

@Entity()
@Index('ix_group_0', (group: Group) => [group.domain, group.name], { unique: true })
@ObjectType({ description: 'A group used to organize and manage boards.' })
export class Group {
  @PrimaryGeneratedColumn('uuid')
  @Field(type => ID, { description: 'Unique identifier for the group.' })
  readonly id: string

  @ManyToOne(type => Domain)
  @Field(type => Domain, { nullable: true, description: 'The domain to which this group belongs.' })
  domain?: Domain

  @RelationId((group: Group) => group.domain)
  domainId?: string

  @Column()
  @Field({ description: 'The name of the group.' })
  name: string

  @Column({
    nullable: true
  })
  @Field({ nullable: true, description: 'A detailed description of the group.' })
  description?: string

  @OneToMany(type => Board, board => board.group)
  @Field(type => [Board], { nullable: true, description: 'The list of boards belonging to this group.' })
  boards: Board[]

  @CreateDateColumn()
  @Field({ nullable: true, description: 'The timestamp when the group was created.' })
  createdAt?: Date

  @UpdateDateColumn()
  @Field({ nullable: true, description: 'The timestamp when the group was last updated.' })
  updatedAt?: Date

  @ManyToOne(type => User, { nullable: true })
  @Field(type => User, { nullable: true, description: 'The user who created the group.' })
  creator?: User

  @RelationId((group: Group) => group.creator)
  creatorId?: string

  @ManyToOne(type => User, { nullable: true })
  @Field(type => User, { nullable: true, description: 'The user who last updated the group.' })
  updater?: User

  @RelationId((group: Group) => group.updater)
  updaterId?: string
}
